import { render, staticRenderFns } from "./line2.vue?vue&type=template&id=5ed4b6b2&scoped=true&"
import script from "./line2.vue?vue&type=script&lang=js&"
export * from "./line2.vue?vue&type=script&lang=js&"
import style0 from "./line2.vue?vue&type=style&index=0&id=5ed4b6b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed4b6b2",
  null
  
)

export default component.exports